<script lang="ts" setup>
import { onMounted, ref, type Ref, toRefs } from 'vue';
import { Event } from '@/models/Event';
import { instance as api } from '@/helpers/api';

const props = defineProps<{
    record: Event;
}>();
const { record } = toRefs(props);

const importdataHtml: Ref<string | null> = ref(null);

const loadImportdataHtml = async () => {
    try {
        const ret = await api().get('/Event/loadImportdataHtml', {
            params: { id: record.value.id },
        });
        if (ret?.data) {
            importdataHtml.value = String(ret.data);
        }
    } catch (e) {
        // pass
    }
};

onMounted(() => {
    loadImportdataHtml();
});
</script>

<template>
    <v-container fluid class="pa-5 overflow-auto" v-html="importdataHtml">
    </v-container>
</template>

<style scoped lang="scss">
:deep(pre) {
    background-color: white;
    padding: 0.5rem;
    white-space: pre-wrap;
}
</style>
